<template>
    <div class="layout-detail-relation">
        <div v-for="relation in relationList" class="layout-drl-list dsp-flex" v-bind:class="{'layout-drl-list-green' : relation.type <= 3, 'layout-drl-list-yellow' : relation.type > 3}">
            <div v-for="itemData in allList" class="layout-drl-item-box">
                <div class="layout-drl-item" v-bind:class="'layout-drl-item' + relation.length + '-l' + relation['index'][0]" v-show="allList.indexOf(itemData) == 0">
                    <span class="drl-line"></span>
                    <span v-show="relation['index'].length == 2" class="drl-text drl-text-l">{{relation.text.charAt(0)}}</span>
                    <span v-show="relation['index'].length == 2" class="drl-text drl-text-r">{{relation.text.charAt(1)}}</span>
                    <span v-show="relation['index'].length == 3" class="drl-text drl-text-l">{{relation.text.charAt(0)}}</span>
                    <span v-show="relation['index'].length == 3" class="drl-text" v-bind:class="'drl-text-m' + relation['index'][1]">{{relation.text.charAt(1)}}</span>
                    <span v-show="relation['index'].length == 3" class="drl-text drl-text-r">{{relation.text.charAt(2)}}</span>
                    <span class="drl-result">{{relation.result}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailRelation',
    props: ['allList', 'relationList'],
    computed: {

    },
    mounted: function() {
        // Todo forTest
        // var listDiv = document.getElementsByClassName('layout-drl-list')[0];
        // listDiv.style.height = '400px';
    },
    methods: {

    }
}
</script>